export const TYPE={//分账方类型
1:'固定金额',
2:'每月固定的某一天',

}

export const VALIDATE_TYPE={//提现验证类型
    1:'验证码',
    2:'密码',
}

